import React from "react";
import Select from "react-select";
import ReactDatePicker from "react-datepicker";
import { Calendar } from "react-feather";

export default function DateRange(props) {
	return (

		<>
			{props.isForFacilitator?
			(
				<>
			{props.hideDropdown ? (
				<div>
					<span>{props.label}</span>
				</div>
			) : (
				<Select
					placeholder="Select Date Filter"
					options={props.options}
					onChange={props.onDateFilterChange}
					value={props.dateFilter}
				></Select>
			)}

				<ReactDatePicker
					dateFormat="dd/MM/yyyy"
					selected={props.fromDate}
					onChange={(date) =>
						props.onDateRangeChange("fromDate", date)
					}
					placeholderText="From Date"
					// minDate={new Date()}
				/>
				<ReactDatePicker
					dateFormat="dd/MM/yyyy"
					selected={props.toDate}
					onChange={(date) => props.onDateRangeChange("toDate", date)}
					// minDate={new Date()}
					placeholderText="To Date"
				/>
		</>
			)
			:(
				<div className="row">
			{props.hideDropdown ? (
				<div className="col-md-4" style={{ marginTop: "15px" }}>
					<span>{props.label}</span>
				</div>
			) : (
				<div className="col-md-4" style={{ marginTop: "10px" }}>
					<Select
						placeholder="Select Date Filter"
						options={props.options}
						onChange={props.onDateFilterChange}
						value={props.dateFilter}
					></Select>
				</div>
			)}

			<div className="mt-2 col-md-4">
				<label>From:</label>
				<ReactDatePicker
					dateFormat="dd/MM/yyyy"
					selected={props.fromDate}
					onChange={(date) =>
						props.onDateRangeChange("fromDate", date)
					}
					// minDate={new Date()}
				/>
			</div>
			<div className="mt-2 col-md-4">
				<label>To:</label>
				<ReactDatePicker
					dateFormat="dd/MM/yyyy"
					selected={props.toDate}
					onChange={(date) => props.onDateRangeChange("toDate", date)}
					// minDate={new Date()}
				/>
			</div>
		</div>
			)}
		</>
			
	);
}
